//eslint-disable import/first

import React from 'react';
import EightDItem from './EightDItem';
import { FixedSizeList as List } from 'react-window';

class EightDList extends React.Component {

  render() {
    const data = this.props.items;
    // data[index].validationInformation
    return (
      <ul className="list">
        <List
          height={35*data.length}
          itemCount={data.length}
          itemSize={33}
          width="100%"
        >
        {({ index , style }) => (
          <div style={style}>
            <EightDItem
              key={Date.now()+"-"+data[index]._id}
              id={data[index]._id}
              progression={data[index].progression.globalPercentage}
              user={data[index].user}
              title={data[index].content['information']['title']}
              information={data[index].content['information']}
              isincompleted={data[index].content.isincompleted}
              validationInformation={{"user":"","timestamp":"","validationStatus":"document_validation_status_draft"}}
              deletepermission={data[index].content.deletepermission}
              small={this.props.small}
              circle={this.props.circle}
              translate={this.props.translate}
              endpoint={this.props.endpoint}
            />
          </div>
        )}
        </List>
      </ul>
    );
  }
}

export default EightDList;
